import React, { useState } from "react";
import Link from "next/link";
import { useSelector, useDispatch } from "react-redux";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet,
  WalletConnectButton,
} from "@sei-js/react";
import { acceptBidHandle } from "../../api/index";
import { acceptBid } from "../../utils/api";
import { toast } from "react-toastify";

const DECIMAL = 1000000;

const OfferTab = () => {
  const { connectedWallet, accounts, disconnect } = useWallet();
  const { cosmWasmClient: queryClient } = useCosmWasmClient();
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const [loading, setLoading] = useState(false);

  const { nftBids, seiPrice } = useSelector((state) => state.marketplace);

  const acceptHandle = async (data) => {
    if (accounts.length <= 0) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 3000,
      });
    }

    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 3000,
      });
    }

    setLoading(true);

    let id = toast.loading("Accept Bidding...", {
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: 3000,
    });

    const res = await acceptBidHandle(signingClient, accounts[0].address, {
      ...data,
    });

    if (res.success) {
      await acceptBid({ ...data, address: accounts[0].address });
      toast.update(id, {
        render: "Accept successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "Got Error",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }

    setLoading(false);
  };

  return (
    <>
      {/* <!-- Offers --> */}
      <div
        className="tab-pane fade show active"
        id="offers"
        role="tabpanel"
        aria-labelledby="offers-tab"
      >
        <div
          role="table"
          className="scrollbar-custom dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 grid max-h-72 w-full grid-cols-5 overflow-y-auto rounded-lg rounded-tl-none border bg-white text-sm dark:text-white"
        >
          <div className="contents" role="row">
            <div
              className="dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4"
              role="columnheader"
            >
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                Price
              </span>
            </div>
            <div
              className="dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4"
              role="columnheader"
            >
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                USD Price
              </span>
            </div>
            <div
              className="dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4"
              role="columnheader"
            >
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                {/* Floor Difference */}
              </span>
            </div>
            <div
              className="dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4"
              role="columnheader"
            >
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                Expiration
              </span>
            </div>
            <div
              className="dark:bg-jacarta-600 bg-light-base sticky top-0 py-2 px-4"
              role="columnheader"
            >
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                From
              </span>
            </div>
          </div>
          {nftBids.map((item, index) => {
            const { price, id, buyer, seller } = item;
            return (
              <div className="contents" role="row" key={index}>
                <div
                  className="dark:border-jacarta-600 border-jacarta-100 flex items-center whitespace-nowrap border-t py-4 px-4"
                  role="cell"
                >
                  <span className="-ml-1" data-tippy-content="ETH">
                    <svg className="icon mr-1 h-4 w-4">
                      <use xlinkHref="/icons.svg#icon-ETH"></use>
                    </svg>
                  </span>
                  <span className="text-green text-sm font-medium tracking-tight">
                    {(price / DECIMAL).toFixed(3)} SEI
                  </span>
                </div>
                <div
                  className="dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4"
                  role="cell"
                >
                  {((price / DECIMAL) * seiPrice).toFixed(4)} $
                </div>
                <div
                  className="dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4"
                  role="cell"
                >
                  {accounts &&
                  accounts.length > 0 &&
                  accounts[0].address == seller ? (
                    <button
                      type="button"
                      onClick={() => acceptHandle(item)}
                      className="bg-accent shadow-accent-volume flex justify-center items-center hover:bg-accent-dark w-30 rounded-full py-2 px-6 text-center font-semibold text-white transition-all"
                    >
                      Accept
                    </button>
                  ) : null}
                </div>
                <div
                  className="dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4"
                  role="cell"
                >
                  in {`10`} months
                </div>
                <div
                  className="dark:border-jacarta-600 border-jacarta-100 flex items-center border-t py-4 px-4"
                  role="cell"
                >
                  <Link href="#">
                    <a className="text-accent">
                      {buyer?.slice(0, 5)}...{buyer?.slice(-3)}
                    </a>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default OfferTab;
